module.exports = __webpack_public_path__ + "static/img/footer_logo.8fd710bb.png";